import { useState } from "react";
import axios from "../axios";

export const useStoreWordTrivia = () => {
  const [submitting, setSubmittimg] = useState(false);
  const [showGameOver, setShowGameOver] = useState(false);
  const [rewards, setRewards] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmitAnswer = async (
    triviaId,
    percentage_of_completion = 0,
    total_no_of_words = 0
  ) => {
    try {
      setSubmittimg(true);
      setError(null);
      const res = await axios.post(
        `/audiences/trivia-words/${triviaId}`,
        JSON.stringify({
          percentage_of_completion: percentage_of_completion, // Convert percentage to decimal (0.8)
          total_no_of_words,
        })
      );
      if (res.status === 200) {
        setSubmittimg(false);
        setRewards(res.data);
        setShowGameOver(true);
      }
    } catch (error) {
      setSubmittimg(false);
      setError(error);
    }
  };

  const resetState = () => {
    setRewards(null);
    setError(null);
    setShowGameOver(false);
  };

  return {
    handleSubmitAnswer,
    submitting,
    setSubmittimg,
    showGameOver,
    setShowGameOver,
    rewards,
    error,
    resetState,
  };
};
